import { dispatch } from '@rematch/core';

// Shared pre-check used before any credit-consuming action (playbook create/
// generate/export/copy/etc). Mirrors the server's subscription-check-hook math
// (allowedLimit - currentUsage vs requiredCredits) so the UI can block before
// even calling the API.
//
// Returns true if the action is blocked (caller must stop), false if it can proceed.
export function isBlockedBySubscriptionLimit({
    accountSubscriptionDetail,
    selectedAccount,
    user,
    requiredCredits,
    entity,
    entityType,
}) {
    const isEnterprisePlan = selectedAccount && selectedAccount.planDisplayName && /enterprise/i.test(selectedAccount.planDisplayName);
    if (isEnterprisePlan) {
        return false;
    }

    const usageMeter = (accountSubscriptionDetail && accountSubscriptionDetail.usageMeter) || {};
    const availableCredits = (usageMeter.allowedLimit || 0) - (usageMeter.currentUsage || 0);

    if (usageMeter.allowedLimit < 0 || availableCredits > requiredCredits) {
        return false;
    }

    // Reserved/free-credits top-up flow is de-scoped for the Aspenify 2.0 (July 2026)
    // launch per Steve's review — kept here, commented out, so it can be
    // restored when the feature comes back instead of rebuilding it from scratch.
    // const accountId = selectedAccount && selectedAccount._id;
    // const isCustomerAdmin = user && user.accounts && user.accounts.some(
    //     (account) => account.id && account.id.toString() === (accountId || '').toString() && account.role === 'customerAdmin'
    // );
    // const freeCreditsRemaining = (selectedAccount && selectedAccount.freeCreditsRemaining) || 0;
    //
    // if (isCustomerAdmin && freeCreditsRemaining > 0) {
    //     dispatch.app.setTopUpCreditsModal(true);
    //     dispatch.app.setTopUpCreditsProps({
    //         entity,
    //         entityType,
    //         availableCredits,
    //         requiredCredits,
    //         freeCreditsRemaining,
    //     });
    //     return true;
    // }

    dispatch.app.setSubscriptionLimitError(true);
    dispatch.app.setSubscriptionLimitProps({
        entity,
        entityType,
        availableCredits,
        requiredCredits,
    });
    return true;
}
